import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { appName } from "../Conf";
import { Link } from "react-router-dom";
import { Icon, LinearProgress } from "@mui/material";

const drawerWidth = 240;

function ResponsiveDrawer(props) {
  const { window, menus, loading } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <Toolbar />
      <List>
        {menus
          .filter((j) => !j.subOf)
          .map((menu, index) => (
            <div key={index}>
              <ListItem
                style={{
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                  padding: "5px 15px",
                }}
              >
                <ListItemText>
                  <div style={{ fontWeight: 600, fontSize: "1.1rem" }}>
                    {menu.label}
                  </div>
                </ListItemText>
              </ListItem>
              {menus
                .filter((j) => j.subOf === menu.menuId)
                .map((subMenu, key) => (
                  <div key={key}>
                    <ListItem
                      button
                      style={{
                        padding: "5px 15px",
                      }}
                      component={Link}
                      to={subMenu.path || "/"}
                    >
                      <ListItemIcon style={{ minWidth: "40px" }}>
                        <Icon>{subMenu.icon}</Icon>
                      </ListItemIcon>
                      <ListItemText>
                        <div>{subMenu.label}</div>
                      </ListItemText>
                    </ListItem>
                  </div>
                ))}
            </div>
          ))}
      </List>
      <Divider />
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            {appName}
          </Typography>
          <IconButton
            edge="end"
            onClick={() => props.onSignOut()}
            color="inherit"
          >
            <Icon>lock_open</Icon>
          </IconButton>
        </Toolbar>

        {loading === true && <LinearProgress />}
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          marginBottom: "15px",
        }}
      ></Box>
    </Box>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;
